import { render, staticRenderFns } from "./marketReserch.vue?vue&type=template&id=0957155b&scoped=true&"
import script from "./marketReserch.vue?vue&type=script&lang=js&"
export * from "./marketReserch.vue?vue&type=script&lang=js&"
import style0 from "./marketReserch.vue?vue&type=style&index=0&id=0957155b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957155b",
  null
  
)

export default component.exports